import { createAction } from "@reduxjs/toolkit";

export const recommendationFetchComplete = createAction<any>("recommendations/complete");

export const inventoryFetch = createAction("inventory/pending");

export const inventoryFetchComplete = createAction<any>("inventory/complete");

export const cometMessage = createAction<any>("comet/message");
